'use client';

import type { ProgramDetails } from '@/modules/Entertainment/interface/Program';
import type { FC } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { Seasons } from '@/modules/Advisory/ui/ContentsSection/Seasons';
import { useGetProgramFiles } from '@/modules/Entertainment/http/client/useGetProgramFiles';
import { useGetProgramRelated } from '@/modules/Entertainment/http/client/useGetProgramRelated';
import { useGetProgramWallets } from '@/modules/Entertainment/http/client/useGetProgramWallets';
import { IfRender } from '@/utils/jsx';
import { ProgramRelatedContent } from '../ProgramRelatedContent';
import { RecommendedWallets } from '../RecommendedWallets';
import { SupplementaryMaterials } from '../SupplementaryMaterials';

export const ResearchTabs: FC<ResearchTabsProps> = ({
  programId,
  programTitle,
  disableRelated = false,
}) => {
  const t = useT();

  const { data: wallets = [], isFetching: isLoadingWallet } =
    useGetProgramWallets(programId);
  const { data: files = [] } = useGetProgramFiles(programId);
  const { data: related = [] } = useGetProgramRelated(programId);

  return (
    <Flex flexDir="column" gap="6xl" w="full">
      <RecommendedWallets
        wallets={wallets}
        programTitle={programTitle}
        isLoading={isLoadingWallet}
      />
      <Flex flexDir="column" gap="l">
        <Text size="h6" fontWeight="normal">
          {`${t('attributes.contents')} do ${programTitle}`}
        </Text>
        <Seasons slug={programId} isRestricted={false} />
      </Flex>
      <SupplementaryMaterials files={files} />
      <IfRender condition={!disableRelated}>
        <ProgramRelatedContent data={related} />
      </IfRender>
    </Flex>
  );
};

type ResearchTabsProps = {
  programId: ProgramDetails['id'];
  programTitle: ProgramDetails['title'];
  disableRelated?: boolean;
};
